import { useEffect, useState } from "react";
import { trackEvent } from "../../../Actions/Utils";

const QuestionChips = ({
  selectedLanguage,
  options,
  saveResponse = () => {},
  textSize,
  disabled,
  selectedChipIndex,
  idx,
  questionChipClicked = () => {},
}) => {
  return (
    <div className="flex flex-col" id={`tour-question-chips-${typeof idx !== 'undefined' ? idx : 0}`}>
      {options.map((option, optionIdx) => {
        return (
          <div
            key={optionIdx}
            className={`flex min-h-16 items-center rounded-lg border border-solid border-1 border-[var(--primary-dark)] gap-3 p-2 mb-2 ${disabled ? 'bg-[var(--light-neutral-3)] opacity-60 border-[var(--light-neutral-3)]': 'bg-[var(--neutral-white)]'} ${selectedChipIndex == optionIdx ? 'opacity-100 bg-[var(--primary-dark)] text-[var(--neutral-white)]': 'text-[var(--primary-dark)]'}`}
            onClick={() => {
              questionChipClicked();
              saveResponse(optionIdx, option[selectedLanguage], false, null);
              trackEvent("Default Chips	", "Click", "click on default questions");
            }}
            style={{fontSize: `${textSize}rem`}}
          >
            {option[option[selectedLanguage] ? selectedLanguage : "en"]}
          </div>
        );
      })}
    </div>
  );
};

export default QuestionChips;
